import React from 'react'

interface CustomLinkProps {
  href: string
  children?: React.ReactNode
  className?: string
  target?: string
  rel?: string
}

const Link: React.FC<CustomLinkProps> = ({ href, children, className, target, rel, ...rest }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    window.location.href = href
  }

  return (
    <a
      href={href}
      className={`${className} flex items-center justify-center lg:flex`}
      onClick={handleClick}
      target={target}
      rel={rel}
      {...rest}
    >
      {children}
    </a>
  )
}

export default Link
